import { Button, Col, Drawer, Form, Input, Modal, Row, Select, Space, Table, Tooltip } from 'antd';
import { ColumnsType } from 'antd/es/table';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { AppState } from 'src/store';
import { ActivityDataPortfolio, Loan } from 'src/store/portfolio/types';
import { HddOutlined, CloseCircleOutlined, SearchOutlined, PlusCircleOutlined, LockOutlined, UserOutlined, CreditCardOutlined, MailOutlined, PhoneOutlined, EditOutlined, DeleteOutlined, ExperimentOutlined, FundOutlined } from '@ant-design/icons';
import style from '../Tables.module.scss'
import { SizeType } from 'antd/es/config-provider/SizeContext';
import validateMessages from 'src/globals/Inputs/validateMessages';
import { EmissionsSource } from 'src/store/emissions/types';
import { getTransformationFactorsUnitByEmissionorganizationId, getTransformationFactorsUnitByEmissionId, getTransformationFactorsUnitByEmissionSourceId } from "src/store/transformationfactors/thunks";
import { openNotification } from 'src/globals/Components/Notification/Notificaction';
import { getEmissionsOrganization } from 'src/store/emissions/thunks';
import { PostPortfolioActivityData, getActivityDataPortfolio, DeletePortfolioActivityData, putPortfolioActivityData } from 'src/store/portfolio/thunks';
import initCollapseMotion from 'antd/es/_util/motion';
import AdminHeader from 'src/globals/Layout/Admin/AdminHeader';
import LoadingIndicator from 'src/globals/Components/Loading/LoadingIndicator';
import { DataTypePortafolio } from './TPortafolioOrganizations';

interface ActivityDataPortfolioProps {
  showModal: boolean;
  closeDrawer: () => void;
  Portfolio: Loan | undefined;
  organizationData: DataTypePortafolio | undefined;
  getActivityDataPortfolio?: any;
  getTransformationFactorsUnitByEmissionSourceId?: any;
  getEmissionsOrganization?: any;
  PostPortfolioActivityData?: any;
  DeletePortfolioActivityData?: any;
  putPortfolioActivityData?: any;
}


type RequiredMark = boolean | 'optional';

const TActivityDataPortfolio: React.FC<ActivityDataPortfolioProps> = (props: ActivityDataPortfolioProps) => {
  const [isModalOpenActivity, setIsModalOpenActivity] = useState(false);
  const [showFlow, setshowFlow] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();
  const [isFormValidate, setIsFormValidate] = useState(true);
  const [typeModal, setTypeModal] = useState(true);
  const [typeActivity, setTypeActivity] = useState("");
  const [typeModalActivity, setTypeModalActivity] = useState(true);
  const [searchValue, setSearchValue] = useState<EmissionsSource>();
  const [dataBaseUnit, setDataBaseUnit] = useState([]);
  const [selectDataTableEmissions, setSelectDataTableEmissions] = useState<EmissionsSource[]>([]);
  const { Option } = Select;
  const [isActivityDataPortfolio, setActivityDataPortfolio] = useState<ActivityDataPortfolio[] | undefined>();
  const [isModalDeleteMethodOpen, setIsModalDeleteMethodOpen] = useState(false);
  const [formDeleteActivity] = Form.useForm();
  const [requiredMark, setRequiredMarkType] = useState<RequiredMark>('optional');
  const [componentSize, setComponentSize] = useState<SizeType | 'default'>('default');
  const [isActivityData, setActivityData] = useState<ActivityDataPortfolio>();
  const [selectedGroup, setSelectedGroup] = useState<string | null>(null);
  const [formActivityEvent] = Form.useForm();
  const init = async () => {
    const response = await props.getActivityDataPortfolio(props.Portfolio?.id);
    setActivityDataPortfolio(response);
  }
  useEffect(() => {
    init();
  }, [props.Portfolio]);


  const handleDeleteMethodCancel = () => {
    setIsModalDeleteMethodOpen(false);
  };

  const columnsLoans: ColumnsType<ActivityDataPortfolio> = [
    {
      title: '',
      width: 10,
      dataIndex: 'key',
      key: 'key',

    },
    {
      title: '',
      width: 0,
      dataIndex: 'id',
      key: 'id',
      render: () => null,
    },
    {
      title: 'Fuente de Emisión',
      width: 50,
      dataIndex: 'emissionSourceName',
      key: 'emissionSourceName',
      render: (text, record) => record.emissionSourceName || '-', // Nombre de la fuente de emisión
    },
    {
      title: '',
      width: 0,
      dataIndex: 'emissionSourceId',
      key: 'emissionSourceId',
      render: () => null,
    },
    {
      title: 'Nombre de la Fuente',
      width: 50,
      dataIndex: 'sourceName',
      key: 'sourceName',
      render: (text, record) => record.sourceName || '-', // Nombre de la fuente
    },
    {
      title: 'Unidad Base',
      width: 30,
      dataIndex: 'baseUnit',
      key: 'baseUnit',
      render: (text, record) => record.baseUnit || '-', // Unidad base
    },
    {
      title: 'Ingreso de Datos',
      width: 40,
      dataIndex: 'dataIncome',
      key: 'dataIncome',
      render: (text, record) => record.dataIncome.toFixed(2) || '0.00', // Ingreso de datos (formateado a dos decimales)
    },
    {
      title: 'Datos',
      width: 40,
      dataIndex: 'data',
      key: 'data',
      render: (text, record) => record.data.toFixed(2) || '0.00', // Datos (formateado a dos decimales)
    },
    {
      title: 'Unidad',
      width: 30,
      dataIndex: 'unit',
      key: 'unit',
      render: (text, record) => record.unit || '-', // Unidad (si está presente)
    },
    {
      title: 'Observación',
      width: 60,
      dataIndex: 'observation',
      key: 'observation',
      render: (text, record) => record.observation || '-', // Observación (si está presente)
    },
    {
      title: '',
      width: 0,
      dataIndex: 'portfolioId',
      key: 'portfolioId',
      render: () => null, // ID del portafolio
    },
    {
      title: '',
      key: 'operation',
      fixed: 'right',
      width: 30,

      render: (record: ActivityDataPortfolio) =>
        <Space size="middle">
          <Tooltip placement="topRight" title="Actualizar">
            <Button
              type="text"
              className={style["update-button"]}
              onClick={() => setActivityDataUpdate(record)}
              icon={<EditOutlined />}
            />
          </Tooltip>
          <Tooltip placement="topRight" title={validateMessages.deleteButton} >
            <Button
              type="text"
              className={style["eliminate-button"]}
              onClick={() => setDeleteActivityData(record)}
              icon={<CloseCircleOutlined />}
            >

            </Button>
          </Tooltip>


        </Space>,
    },

  ];


  const setActivityDataUpdate = async (record: ActivityDataPortfolio) => {
    try {
      const responseData = await props.getEmissionsOrganization(props.organizationData?.id)
      setSelectDataTableEmissions(responseData)
      setshowFlow(false);
      setActivityData(record);    

      setIsModalOpenActivity(true);
      setTypeModal(false);
    } catch (error) {
      openNotification("Error", "No se pudo cargar las Emisiones para la organización seleccionada.");
    }
  };

  const setDeleteActivityData = (record: ActivityDataPortfolio) => {
    setIsModalDeleteMethodOpen(true);
    setActivityData(record);
  }


  const deleteActivityData = async () => {
    if (isActivityData != undefined) {

      setIsModalDeleteMethodOpen(false);
      await props.DeletePortfolioActivityData(isActivityData?.id)
      setIsModalDeleteMethodOpen(false);
      const dataActivity = await props.getActivityDataPortfolio(props.Portfolio?.id);
      setActivityDataPortfolio(dataActivity);
    }
  }

  const onFormLayoutChange = ({ size }: { size: SizeType }) => {
    setComponentSize(size);
  };


  const handleCancel = () => {
    form.resetFields();
    setIsModalOpen(false);
  };

  const handleOk = () => {
    form.resetFields();
    setIsModalOpen(false);
  };

  const onFinishValidate = async (values: any) => {
    if (values.code == undefined) {
      values.code = "A";
    }
    const Postregister = {
      PortfolioId: props.Portfolio?.id,
      baseUnit: values.baseUnit,
      DataIncome: values.data,
      observation: values.observation,
      MsIdentityEmissionSourcesId: searchValue?.id
    };

    const Putregister = {
      id: isActivityData?.id,
      PortfolioId: isActivityData?.portfolioId,
      baseUnit: values.baseUnit,
      dataIncome: values.data,
      observation: values.observation,
      MsIdentityEmissionSourcesId: searchValue?.id ? searchValue?.id : isActivityData?.emissionSourceId
    };
    //handleCancelActivity();
    setIsModalOpen(false);
    if (typeModal) {
      await props.PostPortfolioActivityData(Postregister);
    }
    else {
      await props.putPortfolioActivityData(Putregister);
    }

    const dataActivity = await props.getActivityDataPortfolio(props.Portfolio?.id);
    setActivityDataPortfolio(dataActivity);
    form.resetFields();
  }

  const showModalCreate = async () => {
    try {
      setshowFlow(false);
      const responseData = await props.getEmissionsOrganization(props.organizationData?.id)
      setSelectDataTableEmissions(responseData)

      form.resetFields();
      form.setFieldsValue({
      });

      setIsModalOpenActivity(true)
      setTypeModal(true)
    } catch (error) {
      openNotification("Error", "No se pudo cargar las fuentes de emision.");
    }

  }

  const uniqueGroups = Array.from(
    new Set(selectDataTableEmissions.map((item) => item.group))
  );

  const onFinishActivity = async (values: any) => {

    if (values.code == undefined) {
      values.code = "A";
    }
    const Postregister = {
      PortfolioId: props.Portfolio?.id,
      baseUnit: values.baseUnit,
      DataIncome: values.data,
      observation: values.observation,
      MsIdentityEmissionSourcesId: searchValue?.id
    };

    const Putregister = {
      id: isActivityData?.id,
      PortfolioId: isActivityData?.portfolioId,
      baseUnit: values.baseUnit,
      dataIncome: values.data,
      observation: values.observation,
      MsIdentityEmissionSourcesId: searchValue?.id ? searchValue?.id : isActivityData?.emissionSourceId
    };
    //handleCancelActivity();
    setIsModalOpenActivity(false)
    if (typeModal) {
      await props.PostPortfolioActivityData(Postregister);
    }
    else {
      await props.putPortfolioActivityData(Putregister);
    }
    const dataActivity = await props.getActivityDataPortfolio(props.Portfolio?.id);
    setActivityDataPortfolio(dataActivity);
    form.resetFields();
  }
  const filteredEmissions = selectedGroup
    ? selectDataTableEmissions.filter((item) => item.group === selectedGroup)
    : [];
  return (
    <>
      <Drawer placement={"bottom"} width={1250} height={'100%'} open={props.showModal} onClose={props.closeDrawer}>
        <AdminHeader>Data de actividad de {props.organizationData?.name} </AdminHeader>
        <Button
          type="primary"
          icon={<PlusCircleOutlined />}
          className={style["create-button-user"]}
          onClick={showModalCreate}
        >
          Registrar Actividad
        </Button>
        <Table size="small" columns={columnsLoans} dataSource={isActivityDataPortfolio} scroll={{ x: 500 }} />

        <Modal open={isModalOpen} onOk={handleOk} onCancel={handleCancel}
          width={350} footer={null}       >
          <AdminHeader className={style["title-modal"]}>
            {typeModal ? "Registrar actividad" : "Actualizar actividad"}
          </AdminHeader>
          <Form
            form={form}
            layout="vertical"
            onFinish={onFinishValidate}
          >
            <Form.Item label="Fuente de emisión" name="MsIdentityEmissionSourcesId" rules={[{ required: true, message: validateMessages.emptyField }]}>
              <Select
                showSearch
                style={{ width: "100%" }}
                //onChange={handleSelectChangeEmission}
                onChange={async (selectedId: string, option: any) => {
                  setTypeActivity(selectedId);
                  const datValue: EmissionsSource | undefined = selectDataTableEmissions.find((emission) => emission.id === selectedId);
                  setSearchValue(datValue);
                  const responseDataBaseUnit = await props.getTransformationFactorsUnitByEmissionSourceId(datValue?.id);
                  setDataBaseUnit(responseDataBaseUnit);
                }
                }
                filterOption={(input: any, option: any) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                placeholder="Escoga la fuente de emisión"
              >
                {selectDataTableEmissions.map((type: EmissionsSource) => (
                  <Option key={`type-option-${type.id}`} value={type.id}
                  >
                    {type.name + "-" + type.flow}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item label="Unidad base" name="baseUnit" rules={[{ required: true, message: validateMessages.emptyField }]}>
              <Select
                showSearch
                style={{ width: "100%" }}
                filterOption={(input: any, option: any) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }

                value={searchValue}
                placeholder="Escoga la unidad base"
              >
                {dataBaseUnit.map((type: string) => (
                  <Option key={`type-option-${type}`} value={type}
                  >
                    {type}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              name="data"
              label="Dato"
              rules={[{ required: true, message: validateMessages.emptyField }]}
            >
              <Input placeholder="Ingresar dato" />
            </Form.Item>
            <Form.Item>
              <Button className={style["create-button-user"]} type="primary" htmlType="submit">
                {typeModal ? "Agregar" : "Actualizar"}
              </Button>
            </Form.Item>
          </Form>
        </Modal>
        <Modal open={isModalDeleteMethodOpen} onCancel={handleDeleteMethodCancel} onOk={deleteActivityData}>
          <h3>¿Esta seguro que desea eliminar la actividad? </h3>
        </Modal>
        <Modal
          title={<span className={style.title}>{typeModal ? "Nueva Actividad" : "Actualizar Actividad"}</span>}
          open={isModalOpenActivity}
          onCancel={() => setIsModalOpenActivity(false)}
          width={1000}
          footer={null}
          className={style.modalContentStyle} // Aplicar el estilo al Modal
        >

          {!showFlow ? <div className={style["card-container-portf"]}>
            <Row justify="start" >
              {uniqueGroups.map((group, index) => (
                <Col xxl={8} xl={4} lg={4} md={4} sm={24} xs={24}>
                  <div className={style["card"]} onClick={() => {
                    setSelectedGroup(group);  // guardas el grupo
                    setshowFlow(true);                    
                    if(typeModal){
                       formActivityEvent.resetFields() 
                    }
                          // muestras el formulario
                  }}>
                    <p className="text-gray-600">{group}</p>
                  </div>
                </Col>
              ))}
            </Row>
          </div> :

            <Form form={formActivityEvent}
              layout="vertical"
              initialValues={{ requiredMarkValue: requiredMark }}
              requiredMark={requiredMark}
              onFinish={onFinishActivity}
              onValuesChange={onFormLayoutChange}
              size={componentSize as SizeType}
            >

              <Form.Item
                label="Fuente de emisión"
                name="MsIdentityEmissionSourcesId"
                rules={[{ required: true, message: validateMessages.emptyField }]}
              >
                <Select
                  size='large'
                  showSearch
                  style={{ width: "100%" }}
                  onChange={async (selectedId: string, option: any) => {
                    setTypeActivity(selectedId);
                    const datValue: EmissionsSource | undefined = selectDataTableEmissions.find(
                      (emission) => emission.id === selectedId
                    );
                    setSearchValue(datValue);
                    const responseDataBaseUnit =
                      await props.getTransformationFactorsUnitByEmissionSourceId(datValue?.id);
                    setDataBaseUnit(responseDataBaseUnit);
                  }}
                  filterOption={(input: any, option: any) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  placeholder="Escoga la fuente de emisión"
                >
                  {filteredEmissions.map((type: EmissionsSource) => (
                    <Option key={`type-option-${type.id}`} value={type.id}>
                      {type.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item label="Unidad base" name="baseUnit" rules={[{ required: true, message: validateMessages.emptyField }]}>
                <Select
                  size='large'
                  showSearch
                  style={{ width: "100%" }}
                  filterOption={(input: any, option: any) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }

                  value={searchValue}
                  placeholder="Escoga la unidad base"
                >
                  {dataBaseUnit.map((type: string) => (
                    <Option key={`type-option-${type}`} value={type}
                    >
                      {type}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                name="data"
                label="Dato"
                rules={[{ required: true, message: validateMessages.emptyField }]}
              >
                <Input size='large' placeholder="Ingresar dato" />
              </Form.Item>
              <Form.Item>
                <Button className={style["create-button-user"]} type="primary" htmlType="submit">
                  {typeModalActivity ? "Agregar" : "Actualizar"}
                </Button>
              </Form.Item>
              <Button className={style["create-button-user"]} type="primary" onClick={() => {
                setshowFlow(false);
                setSelectedGroup(null);
                formActivityEvent.resetFields()
              }} >
                {"Regresar"}
              </Button>
            </Form>
          }
          <LoadingIndicator />

        </Modal>



        <LoadingIndicator />

      </Drawer>


    </>


  );
};

const mapStateToProps = (state: AppState) => ({

});

export default connect(mapStateToProps, {
  getTransformationFactorsUnitByEmissionorganizationId,
  getTransformationFactorsUnitByEmissionId,
  getTransformationFactorsUnitByEmissionSourceId,
  getEmissionsOrganization,
  PostPortfolioActivityData,
  getActivityDataPortfolio,
  DeletePortfolioActivityData,
  putPortfolioActivityData
})(TActivityDataPortfolio);
